<template>
  <div>
    <FormCreateEdit />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import FormCreateEdit from "../../components/views/banner/BannerCreateEdit.vue";
export default defineComponent({
  components: {
    FormCreateEdit
  },
  setup() {}
});
</script>
